// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2153":"8912a1dd","5770":"8912a1dd"}[chunkId] + ".chunk.css";
};